<template>
    <div v-if="!showProductItem">
        <transition-group name="list" tag="ul">
            <template v-if="checkConditionsToSubGrup(category)">
                <SubGroupCardGom
                    v-for="(subGroup, key) in category && category['subGroups']" :key="category.groupCode+subGroup.subGroupCode+key"
                    class="product_card"
                    :name="getProductLanguage(subGroup, 'subGroupName')"
                    :image="getImagesURL(subGroup, 'subGroupImages')"
                    :subGroup="subGroup"
                    :subGroupIndex="key"
                    @selectCurGroup="selectCurGroup">
                </SubGroupCardGom>
            </template>
            <template v-else>
                <ProductCardGom
                    v-for="(prod, key) in removeProd(subGroupProducts || category && category['products'])" :key="category.groupCode+prod.productCode+key"
                    class="product_card"
                    :name="getProductLanguage(prod, 'productName')"
                    :image="getImagesURL(prod, 'productImages')"
                    :price="prod.price"
                    :prod="prod"
                    :blockProds="blockProds"
                    @selectCurprod="selectCurprod">
                </ProductCardGom>
            </template>
        </transition-group>
        <ProductBarcodeScanner v-if="isScannerEnable()"/>
        <div class="overlay" v-if="showSuggestionsMenuModal"></div>
        <Transition name="bounce">
            <SuggestionsMenuModal v-if="showSuggestionsMenuModal" :productCode="suggestProductCode" :groupCode="suggestGroupCode" @handleSuggestion="handleSuggestion" @closeSuggestionsMenuModal="closeSuggestionsMenuModal" :indexCart="lastIndexNotSuggested" @navigateToGroup="navigateToGroup"></SuggestionsMenuModal>
        </Transition>
    </div>
    <div v-else>
        <Transition name="bounce">
            <ProductItemGom :selectedProduct="curProd" :editProduct="editProduct" :editKey="editKey" @closeProductItem="closeProductItem"></ProductItemGom>
        </Transition>
    </div>
</template>

<script>
/* eslint-disable */
import ProductCardGom from '@/components/ProductCardGom'
import SubGroupCardGom from '@/components/SubGroupCardGom'
import ProductController from '@/assets/controllers/ProductController'
import Util from '@/assets/libs/util'
import LocaleController from '../assets/controllers/LocaleController'
import ProductBarcodeScanner from '@/components/ProductBarcodeScanner'
import ProductItemGom from './ProductItemGom.vue'
import SuggestionsMenuModal from '@/components/SuggestionsComponents/SuggestionsMenuModal'
import eventModule from '@/assets/libs/eventModule'
import CartController from '@/assets/controllers/CartController'
import SuggestionsController from '@/assets/controllers/SuggestionsController'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'ProductGrid',
    props: ['category', 'routeSubGroupIndex', 'blockProds'],
    components: {
        ProductCardGom,
        SubGroupCardGom,
        ProductBarcodeScanner,
        ProductItemGom,
        SuggestionsMenuModal
    },
    data () {
        return {
            enableSubgroups: Util.getLocalConfigs('enableSubgroups'),
            subGroupProducts: null,
            categoryGroupCode: null,
            curProd: null,
            showProductItem: false,
            editKey: null,
            editProduct: null,
            showSuggestionsMenuModal: false,
            suggestProductCode: null,
            suggestGroupCode: null,
            ignoreNextSuggestions: false,
            lastIndexNotSuggested: null
        }
    },
    created () {
        eventModule.$on('openProductItem', this.openProductItem)
        eventModule.$on('closeProductItem', this.closeProductItem)
        eventModule.$on('openSuggestionsMenuModal', this.openSuggestionsMenuModal)
    },
    beforeDestroy () {
        eventModule.$off('openProductItem', this.openProductItem)
        eventModule.$off('closeProductItem', this.closeProductItem)
        eventModule.$off('openSuggestionsMenuModal', this.openSuggestionsMenuModal)
    },
    mounted () {
        this.ignoreNextSuggestions = SuggestionsController.checkIfIgnoreAllSuggestions()
        if (!this.ignoreNextSuggestions) {
            setTimeout(() => {
                this.openSuggestionsMenuModal()
            }, 1000)
        }
    },
    methods: {
        isScannerEnable: function () {
            return Util.allowProdBarCodeRead()
        },
        removeProWithoutImage: function (prods) {
            let produtoSemfoto = Util.getLocalConfigs('produtoSemfoto') === true
            return (prods || []).filter(p => produtoSemfoto || (p.productImages && p.productImages.small))
        },
        removeBlockedProds: function (prods) {
            let blockProds = this.blockProds
            return (prods || []).filter(p => (blockProds.indexOf(p.productCode) === -1))
        },
        removeProd: function (prods) {
            let filtredProds = this.removeProWithoutImage(prods)
            filtredProds = this.removeBlockedProds(filtredProds)
            filtredProds = Util.removeHiddenProducts(filtredProds)
            filtredProds = Util.removeHourlyUnavailableProds(filtredProds)
            return filtredProds
        },
        checkConditionsToSubGrup: function (category) {
            let checkCategorie = category && (category.subGroups.length > 0 && category.subGroups[0].subGroupName)
            return checkCategorie && this.enableSubgroups && !this.subGroupProducts
        },
        selectCurGroup: function (subGroupData) {
            this.subGroupProducts = subGroupData && subGroupData.products
            this.subGroupIndex = subGroupData && subGroupData.subGroupIndex
            this.categoryGroupCode = (subGroupData && subGroupData.groupCode) || ''
            this.$forceUpdate()
        },
        handleSuggestion: function (prod, ignoreNextSuggestions) {
            if (ignoreNextSuggestions) {
                this.ignoreNextSuggestions = true
                this.closeSuggestionsMenuModal()
            }
            this.selectCurprod(prod)
        },
        selectCurprod: function (prod) {
            let seletctedProduct = JSON.parse(JSON.stringify(prod))
            seletctedProduct.catGroupName = this.category && this.category.groupName
            seletctedProduct.categoryGroupCode = (this.category && this.category.groupCode) || ''
            seletctedProduct.subGroupIndex = this.subGroupIndex
            ClarityController.event('usuario_visualizou_produto')
            ClarityController.setTag('produto_visualizado', seletctedProduct.productName)
            if (seletctedProduct.hasComboProducts) {
                ProductController.getProductCombos(prod.productCode).then((values) => {
                    seletctedProduct.productcombosChoice = values
                    this.curProd = seletctedProduct
                    this.openProductItem();
                })
            } else {
                this.curProd = seletctedProduct
                this.openProductItem();
            }
        },
        getImagesURL: function (prod, prop) {
            return Util.getImagesUrl(prod, prop, 'large')
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        openSuggestionsMenuModal: async function () {
            let cart = CartController.getCart()
            if (cart.length === 0) return

            const pendingGroup = SuggestionsController.getPendingGroupSuggestion()
            if (pendingGroup) {
                const lastItem = cart[cart.length - 1]
                const pendingResult = SuggestionsController.confirmPendingGroupSuggestion(
                    (lastItem && lastItem.categoryGroupCode) || ''
                )
                if (pendingResult === 'no_new_product') {
                    return
                }
                if (pendingResult === 'match' && lastItem) {
                    lastItem.productSuggested = true
                }
            }

            // Verifica se já existe um fluxo ativo e mantém o contexto
            const activeFlow = SuggestionsController.getActiveFlowContext()
            if (activeFlow) {
                this.lastIndexNotSuggested = activeFlow.indexCart
                this.suggestProductCode = activeFlow.productCode
                this.suggestGroupCode = activeFlow.groupCode
                this.showSuggestionsMenuModal = true
                return
            }

            // Se há uma sugestão de grupo pendente, não abre o modal ainda
            // Espera o usuário adicionar um produto primeiro
            // const pendingGroup = SuggestionsController.getPendingGroupSuggestion()
            if (pendingGroup) {
                return
            }

            this.lastIndexNotSuggested = cart.findLastIndex(item => !item.productSuggested)
            if (this.lastIndexNotSuggested === -1) return

            let cartItem = cart[this.lastIndexNotSuggested]
            let productCode = cartItem.productCode
            let groupCode = cartItem.categoryGroupCode

            if (!productCode || !groupCode) return

            this.suggestProductCode = productCode
            this.suggestGroupCode = groupCode

            if (!(await SuggestionsController.hasSuggestions(groupCode, productCode))) return
            if (SuggestionsController.checkIfIgnoreAllSuggestions()) return

            this.showSuggestionsMenuModal = true
        },
        closeSuggestionsMenuModal: function () {
            this.showSuggestionsMenuModal = false
            this.suggestProductCode = null
            this.suggestGroupCode = null
        },
        navigateToGroup: function (groupName) {
            this.closeSuggestionsMenuModal()
            eventModule.$emit('navigateToGroup', groupName)
        },
        openProductItem: function (data) {
            if (data) {
                this.editProduct = data.product
                this.editKey = data.key
            }
            this.showProductItem = true;
        },
        closeProductItem: function () {
            this.showProductItem = false;
            
            // Verifica se um produto foi adicionado de um grupo sugerido
            const wasProductAdded = this.curProd !== null
            if (wasProductAdded && this.curProd.categoryGroupCode) {
                SuggestionsController.confirmPendingGroupSuggestion(this.curProd.categoryGroupCode)
            }
            
            this.curProd = null
            this.editKey = null
            this.editProduct = null
            
            // Só abre o modal de sugestões se um produto foi realmente adicionado ao carrinho
            // E não está ignorando sugestões
            if (wasProductAdded && !this.ignoreNextSuggestions) {
                setTimeout(() => {
                    this.openSuggestionsMenuModal()
                }, 500)
            }
        }
    },
    watch: {
        category: function () {
            let sf = this
            sf.selectCurGroup(null)
            this.closeProductItem()
            if (!sf.enableSubgroups && sf.category && sf.category.subGroups.length > 0) {
                let prods = []
                sf.category.subGroups.forEach(sbg => {
                    prods = prods.concat(sbg.products)
                })
                sf.selectCurGroup({products: prods, subGroupIndex: null})
            }
            setTimeout(() => {
                if (sf.routeSubGroupIndex != null && sf.category && sf.category['subGroups'] && sf.enableSubgroups) {
                    let subGroupData = {products: sf.category['subGroups'][sf.routeSubGroupIndex].products, subGroupIndex: sf.routeSubGroupIndex}
                    sf.selectCurGroup(subGroupData)
                }
            }, 300)
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

@import (reference) url("../assets/common.less");

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 4;
}

.product_card {
    display: flex;
    flex-direction: column;
}

ul{
    display: grid;
    grid-template-columns: 50% 50%;
    grid-auto-rows: minmax(380px, auto);
    align-items: stretch;
    position: absolute;
    left: 0;
    width: calc(100% - 20px);
    top: 0;
    padding: 10px 10px 110px 10px;
}

@media (min-width: 699px) and (max-width: 1025px) {
    ul {
        grid-auto-rows: minmax(270px, auto);
    }
}

@media (max-width: 698px) {
    ul {
        grid-auto-rows: minmax(230px, auto);
    }
}

.list-enter-active {
    transition: all .8s ease-in-out;
    transition-delay: .3s;
}

.list-leave-active{
    transition: all .3s ease-in-out;
}

.list-enter {
    transform: translate(-100vw);
}

.list-leave-to {
    opacity: 0;
    transform: translate(0, -100%);
}

@media (orientation: landscape) {
    ul {
        display: grid;
        grid-template-columns: 25% 25% 25% 25%;
        grid-auto-rows: minmax(300px, auto);
        align-items: stretch;
        position: absolute;
        left: 0;
        width: calc(100% - 20px);
        top: 0;
        padding: 10px 10px 110px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductGridGom.vue